// src/lib/supabase.js
// Én Supabase-klient til hele kunde-appen.
//
// Biblioteket kom tidligere fra cdn.jsdelivr.net via et script-tag. Det
// betød, at en tredjepart kunne levere JavaScript ind i portalen, og at
// portalen var nede hvis deres CDN var nede. Nu er det en npm-pakke, der
// bygges ind i vores egne filer og er låst fast i package-lock.json.

import { createClient } from '@supabase/supabase-js';

// Publishable key — beregnet til at ligge i klienten. Adgangen styres af
// Row Level Security i databasen, ikke af at nøglen holdes hemmelig.
export const SUPABASE_URL = 'https://roxmxnugjyvxlmflabkv.supabase.co';
export const SUPABASE_KEY = 'sb_publishable_-C3ix9_OwGicn7Tq2t8fOQ_qmSLjn-i';

export const sb = createClient(SUPABASE_URL, SUPABASE_KEY, {
  auth: {
    persistSession: true,
    // Egen nøgle, så kunde-app og admin-panel ikke deler session.
    storageKey: 'dktec-connect',
    storage: window.localStorage,
    autoRefreshToken: true,
    // Skal være true, ellers ignoreres tokenet i adressen på et
    // nulstillingslink fra e-mail. Den stod på false, og derfor kunne
    // ingen kunde nulstille sin adgangskode: mailen kom frem, linket
    // virkede, men appen så aldrig tokenet.
    //
    // At den er true betyder ikke, at man logges direkte ind fra et
    // nulstillingslink — kerne.js opdager type=recovery i adressen og
    // viser "sæt ny adgangskode" i stedet.
    detectSessionInUrl: true,
  },
});
